import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  message,
  Modal,
  Row,
  Table,
  Input,
  Select,
  Spin,
} from "antd";
import React, { Component } from "react";
import moment from "moment";
import "../Common.global.css";
import locale from "../../constants/locale.json";
const { Option } = Select;
const { confirm } = Modal;

const flexColumnOverflow = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  overflowY: "scroll",
};
const flexColumn = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
};

export default class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
      selectedRows: [],
      users: [],
      roles: [],
      roleId: null,
      userModalVisible: false,
      username: null,
      password: null,
      isNewUser: false,
    };
  }

  componentDidMount() {
    return this.refreshList();
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys, selectedRows });
  };

  refreshList = () => {
    const { accessToken } = this.props;
    this.setState({
      isLoading: true,
    });
    return fetch(`/api/v1/user/list`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        const { users, roles } = data;
        this.setState({
          users,
          roles,
          selectedRowKeys: [],
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  onAddClick = () => {
    this.setState({
      isNewUser: true,
      userModalVisible: true,
    });
  };

  onEditClick = () => {
    const { selectedRows } = this.state;
    this.setState({
      username: selectedRows[0].username,
      roleId: selectedRows[0].role_id,
      isNewUser: false,
      userModalVisible: true,
    });
  };

  onDeleteClick = () => {
    const { selectedRowKeys } = this.state;
    const { accessToken } = this.props;
    const _this = this;
    confirm({
      title: "Please confirm",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you would like to delete the selected user?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        return fetch(`/api/v1/user/${selectedRowKeys[0]}`, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            token: accessToken,
          },
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(res.statusText);
            }
            return res.json();
          })
          .then(() => {
            message.success("Delete Completed!");
            _this.setState({ selectedRowKeys: [] });
            _this.refreshList();
          })
          .catch((err) => {
            message.error(
              err instanceof Error ? err.message : "Server cannot be reached"
            );
          });
      },
    });
  };

  onUserModalCancel = () => {
    this.setState({
      userModalVisible: false,
      username: null,
      password: null,
      roleId: null,
    });
  };

  onUserModalOk = () => {
    const { username, password, roleId, isNewUser, selectedRows } = this.state;
    return fetch(`/api/v1/user/${isNewUser ? "new" : selectedRows[0].id}`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
      body: JSON.stringify({
        username,
        password,
        roleId,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then(() => {
        this.setState({
          userModalVisible: false,
          selectedRows: [],
          username: null,
          password: null,
          roleId: null,
        });
        this.refreshList();
        return message.success(
          `User ${isNewUser ? "Created" : "Updated"} Successfully!`
        );
      })
      .catch(() => {
        message.error("Error creating user!");
      });
  };

  render() {
    const {
      selectedRowKeys,
      selectedRows,
      users,
      userModalVisible,
      username,
      password,
      roles,
      roleId,
      isLoading,
      isNewUser,
    } = this.state;
    const { currentLang } = this.props;
    const rowSelection = {
      type: "radio",
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const columns = [
      {
        title: "Username",
        dataIndex: "username",
        align: "center",
        sorter: (a, b) => a.username.localeCompare(b.username),
      },
      {
        title: "Role",
        dataIndex: "role_display_name",
        align: "center",
        sorter: (a, b) =>
          a.role_display_name.localeCompare(b.role_display_name),
      },
      {
        title: locale.app.common.dateUpdated[currentLang],
        dataIndex: "updated_at",
        ellipsis: true,
        align: "center",
        render: (updated_at) => {
          return <>{moment(updated_at).format("DD/MM/YYYY HH:mm")}</>;
        },
        sorter: (a, b) =>
          moment(a.updated_at).unix() - moment(b.updated_at).unix(),
      },
      {
        title: locale.app.common.dateCreated[currentLang],
        dataIndex: "inserted_at",
        ellipsis: true,
        align: "center",
        render: (inserted_at) => {
          return <>{moment(inserted_at).format("DD/MM/YYYY HH:mm")}</>;
        },
        sorter: (a, b) =>
          moment(a.inserted_at).unix() - moment(b.inserted_at).unix(),
      },
    ];

    return (
      <div className="site-feature-container">
        <div className="page-header-container">
          <div>
            <div className="page-header-main">
              {locale.app.feature.system.title[currentLang]}
            </div>
            <div className="page-header-sub">
              {locale.app.feature.user.title[currentLang]}
            </div>
          </div>
        </div>
        <Card bodyStyle={flexColumn} style={flexColumnOverflow}>
          <Spin tip="Please Wait..." spinning={isLoading}>
            <Row>
              <div className="setting-section-search">
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Col
                    className="setting-detail-group"
                    style={{ padding: "0px" }}
                  >
                    <Button
                      key="Add"
                      className="setting-section-search-btn"
                      type="primary"
                      onClick={this.onAddClick}
                    >
                      {locale.app.common.add[currentLang]}
                    </Button>
                    <Button
                      key="Edit"
                      className="setting-section-search-btn"
                      onClick={this.onEditClick}
                      disabled={selectedRows.length === 0}
                    >
                      {locale.app.common.edit[currentLang]}
                    </Button>
                    <Button
                      key="Delete"
                      className="setting-section-search-btn"
                      danger
                      onClick={this.onDeleteClick}
                      disabled={
                        selectedRows.length === 0 ||
                        selectedRows[0].is_super_user
                      }
                    >
                      {locale.app.common.delete[currentLang]}
                    </Button>
                  </Col>
                </Row>
              </div>
            </Row>
            <Row>
              <div className="table-section-header">
                {locale.app.feature.user.title[currentLang]}
              </div>
              <Table
                rowKey="id"
                style={{ overflow: "auto", width: "100%" }}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={users}
                size="small"
                scroll={{ x: "max-content" }}
              />
            </Row>
          </Spin>
        </Card>
        <Modal
          title={"Add User"}
          closable={false}
          visible={userModalVisible}
          onOk={this.onUserModalOk}
          onCancel={this.onUserModalCancel}
          okButtonProps={{
            disabled: !password || !username || !roleId || isLoading,
          }}
          cancelButtonProps={{ disabled: isLoading }}
        >
          <Row>
            <Col span={24} className="visitor-detail-group">
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Username <span style={{ color: "red" }}>*</span>
                </span>
                <Input
                  className="group-addon-input"
                  name="username"
                  value={username}
                  onChange={(evt) => {
                    this.setState({
                      username: evt.target.value,
                    });
                  }}
                />
              </Input.Group>
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Password <span style={{ color: "red" }}>*</span>
                </span>
                <Input.Password
                  className="group-addon-input"
                  name="password"
                  value={password}
                  onChange={(evt) => {
                    this.setState({
                      password: evt.target.value,
                    });
                  }}
                />
              </Input.Group>
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Role <span style={{ color: "red" }}>*</span>
                </span>
                <Select
                  className="group-addon-input"
                  disabled={!isNewUser}
                  onChange={(roleId) => {
                    this.setState({
                      roleId,
                    });
                  }}
                  value={roleId}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {roles.map((role) => {
                    return (
                      <Option key={role.id} value={role.id}>
                        {role.display_name}
                      </Option>
                    );
                  })}
                </Select>
              </Input.Group>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}
